import * as $ from 'jquery';
import 'datepicker';
import 'selectize';
import { bookingFormSubmit } from "./c005-bookingform-submission";
import { bookingFormCommon } from "./c005-bookingform-common";
import {headerContent} from "./c002";

export class bookingFormBackend {
	private bcommon = new bookingFormCommon();
	/**
	 * Calling login servlet when user submits redemption flow form
	 * @return {any} [description]
	 */
	loginAndBookFlightSubmitHandler(scope:any, redemptionType:string, loginStatus:any): void {
		// console.log('loginAndBookFlightSubmitHandler', scope, redemptionType, loginStatus);
		let _self = this;
  	let bcommon = _self.bcommon;

		bcommon.preloader();

		let loginValidationContainer = scope.find('.redemption-login-error-container');
		let loginValidationText      = scope.find('.redemption-login-errors');
		let fieldMemberID            = scope.find('[data-ibe-redemption--login-id]');
		let fieldMemberLastName      = scope.find('[data-ibe-redemption--lastname]');
		let fieldMemberPassword      = scope.find('[data-ibe-redemption--login-pin]');

		// console.log(loginValidationContainer, fieldMemberID, fieldMemberLastName, fieldMemberPassword);
		// console.log('%cloginFieldsValidation', 'font-weight: bold; font-size: 24px; background-color: red; color: white');
		loginValidationText.empty();
		loginValidationContainer.hide();

		if (loginStatus) {
			let loginTokenCookieVal = document.cookie.match('(^|;)\\s*phantom\\s*=\\s*([^;]+)');
			if (loginTokenCookieVal != null) {
				let loginCookieObject:any;

				loginCookieObject = JSON.parse(loginTokenCookieVal.pop());
				fieldMemberID     = '';

				let milesCountFromProfile = parseInt(loginCookieObject.milesCount);
				let minimumMilesRequired  = -1; /*parseInt($("#minimumMilesCount").val());*/

				if (milesCountFromProfile > minimumMilesRequired) {
					_self.retrieveMemberInfoAndSubmitForm(scope, fieldMemberID, redemptionType, milesCountFromProfile);
				} else {
				 		bcommon.preloaderClose();
					_self.loginAndBookFlightErrorHandler(scope);
				}
			}
		} else {

			let data = {
				'userId': fieldMemberID.val(),
				'password': fieldMemberPassword.val()
			};

			$.ajax({
				type: 'POST',
				url: '/bin/services/new/authuser',
				data: data,
				success: function(msg:any) {
					let json = JSON.parse(msg);
					let responseCode = json.responseCode;
					if (responseCode == "OK") {
						// console.log("Login success");
						var d = new Date();
						d.setTime(d.getTime() + (30 * 60 * 1000));
						var expires = "expires="+d.toUTCString();

						//document.cookie="jade="+json.cookieValue+";"+expires+";path=/";
						document.cookie="phantom="+json.phantomCookieValue+";"+expires+";path=/";
						document.cookie = "userName=" + JSON.parse(json.phantomCookieValue).userName +";"+expires+";path=/";
						document.cookie = "milesCount=" + JSON.parse(json.phantomCookieValue).milesCount + ";"+expires+";path=/";
						document.cookie = "flyerID=" + JSON.parse(json.phantomCookieValue).flyerID + ";"+expires+";path=/"; 
						document.cookie = "memberStatus=" + JSON.parse(json.phantomCookieValue).memberStatus + ";"+expires+";path=/"; 
						
						let loginTokenCookieVal = document.cookie.match('(^|;)\\s*phantom\\s*=\\s*([^;]+)');
						if (loginTokenCookieVal != null) {
							let loginCookieObject:any = void 0;
							loginCookieObject = JSON.parse(loginTokenCookieVal.pop());
							let milesCountFromProfile = parseInt(loginCookieObject.milesCount);
							let minimumMilesRequired = -1; /*parseInt($("#minimumMilesCount").val());*/

							if (milesCountFromProfile > minimumMilesRequired) {
								_self.retrieveMemberInfoAndSubmitForm(scope, fieldMemberID.val(), redemptionType, milesCountFromProfile);
							} else {
								_self.loginAndBookFlightErrorHandler(scope);
							}
						}
					} else if (responseCode == "PW") {
				 		bcommon.preloaderClose();
						fieldMemberPassword.parent().addClass('has-error');
						fieldMemberPassword.parent().find('.booking-form--title').addClass('has-error');
						loginValidationText.append('<span style="display: block">Invalid Membership PIN. You have 4 more attempt(s)</span>').show();
						loginValidationContainer.show();
						return false;
					} else if (responseCode == "LC") {
				 		bcommon.preloaderClose();
						loginValidationText.append($("#exceptionmsg").attr("data-locked")).show();
						loginValidationContainer.show();
						return false;
					} else if (responseCode == "NA") {
				 		bcommon.preloaderClose();
						loginValidationText.append("Invalid Membership ID").show();
						loginValidationContainer.show();
						return false;
					} else if (responseCode == "W2") {
				 		bcommon.preloaderClose();
						fieldMemberPassword.parent().addClass('has-error');
						fieldMemberPassword.parent().find('.booking-form--title').addClass('has-error');
						loginValidationText.append('<span style="display: block">Invalid Membership PIN. You have 3 more attempt(s)</span>').show();
						loginValidationContainer.show();
						return false;
					} else if (responseCode == "W3") {
				 		bcommon.preloaderClose();
						fieldMemberPassword.parent().addClass('has-error');
						fieldMemberPassword.parent().find('.booking-form--title').addClass('has-error');
						loginValidationText.append('<span style="display: block">Invalid Membership PIN. You have 2 more attempt(s)</span>').show();
						loginValidationContainer.show();
						return false;
					} else if (responseCode == "W4") {
				 		bcommon.preloaderClose();
						fieldMemberPassword.parent().addClass('has-error');
						fieldMemberPassword.parent().find('.booking-form--title').addClass('has-error');
						loginValidationText.append('<span style="display: block">Invalid Membership PIN. You have 1 more attempt</span>').show();
						loginValidationContainer.show();
						return false;
					} else if(responseCode == "ST") {
						bcommon.preloaderClose();
						fieldMemberPassword.parent().addClass('has-error');
						fieldMemberPassword.parent().find('.booking-form--title').addClass('has-error');
						loginValidationText.append('<span style="display: block">This is invalid/inactive account. Kindly contact call center for further information</span>').show();
						loginValidationContainer.show();
						return false;
					}else if (responseCode == "TO") {
						bcommon.preloaderClose();
						loginValidationText.append('<span style="display: block">Sorry, we are unable to process your request at this time. please try again later.</span>').show();
						loginValidationContainer.show();
					}
				},
				error: function(error:any) {
			 		bcommon.preloaderClose();
			 		fieldMemberPassword.parent().addClass('has-error');
			 		fieldMemberPassword.parent().find('.booking-form--title').addClass('has-error');
			 		loginValidationText.append('<span style="display: block">Error while authorizing user</span>').show();
			 		loginValidationContainer.show();
					console.log("Error while authorizing user", error);
				}
			});
		}
	}

	/**
	 * [loginAndBookFlightErrorHandler description]
	 * @param {any} scope [description]
	 */
	loginAndBookFlightErrorHandler(scope:any): void {
		// console.log('loginAndBookFlightErrorHandler', scope);
		let loginValidationContainer = scope.find('.redemption-login-error-container');
		let loginValidationText      = scope.find('.redemption-login-errors');

		loginValidationText.append('<span style="display: block">You do not have sufficient miles balance</span>').show();
		loginValidationContainer.show();

		window.location.href = $("#exceptionmsg").attr("data-loginsuccess");
	}
	/**
	 * [retrieveMemberInfoforCash description]
	 * @param {any}    scope                 [description]

	 */
	retrieveMemberInfoForCash($instance:any, param:any, status:any): any {
		let _self = this;
		let bcommon = _self.bcommon;		
		let _gtsAdultIndex: string = '';
		let _gtsChildIndex: string = '';
		if (($('#members-travel--subsidy').length) > 0) {
			$('#members-travel--subsidy input[type=checkbox]').each(function () {
				if (!$(this).hasClass('terms_check_gst')) {
					if ($(this).is(":checked")) {
						if ($(this).parents().eq(5).children().eq(3).find('.traveller-colr').eq(1).text() == 'Adult') {
							if (_gtsAdultIndex == '') {
								_gtsAdultIndex = $(this).val();
							} else {
								_gtsAdultIndex += ',' + $(this).val();
							}
						}
						else {
							if (_gtsChildIndex == '') {
								_gtsChildIndex = ',' + $(this).val();
							} else {
								_gtsChildIndex += ',' + $(this).val();
							}

						}
					}
				}

			});
		}
		let $data = {
			'flyerId': "",
			'payby': 'cashcard',
			'gts_index': _gtsAdultIndex + _gtsChildIndex
		};
		if($('#search-param-cug-matta').length>0){
			if($('#search-param-cug-matta').val()&&$('#search-param-cug-matta').val()!=null ){
				$data['MATTA_CUG'] = 'TRUE';
			}
		}
		bcommon.preloader();
		$.ajax({
			type: 'POST',
			url: '/bin/services/new/retrievemember',
			data: $data,
			success: function(json:any) {
				_self.redirectUser(json);
				json = JSON.parse(json);
				//bcommon.preloaderClose();
				var directLoginParameters = json.directLoginParameters;
				if(status == 'single'){
					var $tripFlowUrl = param + "&"+ directLoginParameters+ "&SO_GL=";
					let $tripflow_encryptURL = encodeURIComponent($tripFlowUrl);
					setTimeout(function () {
						_self.desktopSingleFormSubmitToServlet($instance, $tripflow_encryptURL);                 
					}, 500);
							  	
				}else{
					var $multiTripFlowUrl = param + "&"+ directLoginParameters;
					let $tripflow_encryptURL = encodeURIComponent($multiTripFlowUrl);
					
					_self.desktopMultiFormSubmitToServlet($instance, $tripflow_encryptURL);
					
				}
				
				},
			error: function(error:any) {
				console.log("Error while getting member info", error);
			}
		});
	}

	/**
	 * [retrieveMemberInfoAndSubmitForm description]
	 * @param {any}    scope                 [description]
	 * @param {any}    fieldMemberIDVal      [description]
	 * @param {string} redemptionType        [description]
	 * @param {any}    milesCountFromProfile [description]
	 */
	retrieveMemberInfoAndSubmitForm(scope:any, fieldMemberIDVal:any, redemptionType:string, milesCountFromProfile:any): void {
		let _self = this;		
		let _gtsAdultIndex: string = '';
		let _gtsChildIndex: string = '';
		if (($('#members-travel--subsidy').length) > 0) {
			$('#members-travel--subsidy input[type=checkbox]').each(function () {
				if (!$(this).hasClass('terms_check_gst')) {
					if ($(this).is(":checked")) {
						if ($(this).parents().eq(5).children().eq(3).find('.traveller-colr').eq(1).text() == 'Adult') {
							if (_gtsAdultIndex == '') {
								_gtsAdultIndex = $(this).val();
							} else {
								_gtsAdultIndex += ',' + $(this).val();
							}
						}
						else {
							if (_gtsChildIndex == '') {
								_gtsChildIndex = ',' + $(this).val();
							} else {
								_gtsChildIndex += ',' + $(this).val();
							}

						}
					}
				}

			});
		}		

		// console.log('retrieveMemberInfoAndSubmitForm', scope, fieldMemberIDVal, redemptionType, milesCountFromProfile);
		fieldMemberIDVal = fieldMemberIDVal.replace("MH", "");

		let $data = {
			'flyerId': fieldMemberIDVal,
			'payby': redemptionType,
			'gts_index': _gtsAdultIndex + _gtsChildIndex
		};
		// matta fair cug campaign
		if($('#search-param-cug-matta').length>0){
			if($('#search-param-cug-matta').val()!=null ){
				$data['MATTA_CUG'] = 'TRUE';
			}
		}
		$.ajax({
			type: 'POST',
			url: '/bin/services/new/retrievemember',
			data: $data,
			success: function(json:any) {
				_self.redirectUser(json);
				json = JSON.parse(json);
				var additionalParameters = json.additionalParameters;
				// console.log("Direct login parameters ::" + json.directLoginParameters);
				// console.log("additional parameters ::" + additionalParameters);
				let $officeCode:any;
				let bookingformsubmit = new bookingFormSubmit();
				if (scope[0].hasAttribute('data-ibe--book-flight')) {
					let $instance:any = $(scope);
					$officeCode = _self.desktopOfficeCode($instance);
					bookingformsubmit.singleBookingFormSubmit($instance, json.directLoginParameters, additionalParameters, redemptionType, $officeCode);
				} else if (scope[0].hasAttribute('data-mob-ibe--book-flight')) {
					let $instance:any = $(scope);
					$officeCode = _self.desktopOfficeCode($instance);
					$officeCode = _self.mobileOfficeCode($instance);
					bookingformsubmit.mobileRedemptionBookingFormSubmit($instance, json.directLoginParameters, additionalParameters, redemptionType, $officeCode);
				}
			},
			error: function(error:any) {
				console.log("Error while getting member info", error);
			}
		});
	}

	redirectUser(msg:string): void {
		if(msg.indexOf("timeout") > -1) {
			msg = msg.replace("timeout-","");
			window.location.href = msg;
		}
	}


	/**
   * Form submit to booking engine as redirecting(GET) is not allowed
   * @return {any} [description]
   */
	post_to_url(path: string, params: any): void {
		// console.log('post_to_url', path, params);
		let method: string = "post";
		let form = document.createElement("form");
		if ($('#ibe-standalone-iframe').length > 0) {
			let _self = this;
			let bcommon = _self.bcommon;
			bcommon.preloaderClose();
			form.setAttribute("target", "_blank");
		}
		form.setAttribute("method", method);
		form.setAttribute("action", path);

		for (var key in params) {
			if (params.hasOwnProperty(key)) {
				let hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
				form.appendChild(hiddenField);
			}
		}

		document.body.appendChild(form);
		form.submit();
	}
	post_to_url_refex(url: string, params:any):void{
		let method: string = "post";
		let form = document.createElement("form");
		if ($('#ibe-standalone-iframe').length > 0) {
			let _self = this;
			let bcommon = _self.bcommon;
			bcommon.preloaderClose();
			form.setAttribute("target", "_blank");
		}
		form.setAttribute("method", method);
		form.setAttribute("action", url);

		for (var key in params) {
			if(key in {"isRefex":1,"redirectUrl":1,"languagePayload":1,"success":1}){
				continue;
			}
			let keyname=key;
			if(key==="requestPayload"){
				keyname = "search";
			}
				let hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", keyname);
				if(key == "travelerConfig" || key == "dgpBootstrapJwt" || key == "privateFacts") {
					hiddenField.setAttribute("value", params[key]);
				} else {
					hiddenField.setAttribute("value", JSON.stringify(params[key]));
				}
				form.appendChild(hiddenField);
		}

		document.body.appendChild(form);
		form.submit();
	}
  /**
   * parse source url params into object
   * @param  {string} url [source url with params]
   * @return {any}        [url params object]
   */
	getUrlVars(url:string):any {
	 	let vars:Array<any> = [],
	 			hash:any;
	 	let hashes:any = url.slice(url.indexOf('?') + 1).split('&');

	 	for (var i = 0; i < hashes.length; i++) {
	 		hash = hashes[i].split('=');
	 		vars.push(hash[0]);
	 		vars[hash[0]] = hash[1];
	 	}

	 	return vars;
	}

  /**
   * [desktopSingleFormSubmitToServlet description]
   * @param {any} $tripflow_encryptURL [description]
   */
  desktopSingleFormSubmitToServlet($instance:any, $tripflow_encryptURL: any) {
  	let _self = this;
  	let bcommon = _self.bcommon;
	  let ieversion = new headerContent();
	  ieversion.checkIEVersion_disablePupup();
  	// console.log('desktopSingleFormSubmitToServlet');

 		bcommon.preloader();
  	// Use JQuery AJAX request to post data to a Sling Servlet
  	// console.log("tripflow_encryptURL:" + $tripflow_encryptURL);
  	$.ajax({
  		type: 'POST',
  		url: '/bin/services/new/ibe',
  		data:'url='+ $tripflow_encryptURL,
  		success: function(json:any){
  			// console.log("##Successful: " + json);
			if(json.isRefex){
				if (json.success == "true") {
						let redirectUrl = json.redirectUrl+"?"+json.languagePayload;
						
						_self.post_to_url_refex(redirectUrl, json);
				}
			}else{
				if (json.success == "false" && json.status == "failed" && json.eCode != null) {
					console.log("Error while submitting form" + json);
					bcommon.preloaderClose();
					var _this = this;
					_this.$error = [];
				  //   $instance.find('.booking-error-validation').show();
				  //   $instance.find('.couponcode-input').parent().addClass('has-error');
				  //   $instance.find('.error-validation').show();
				  //   $instance.find('.couponcode-input-mob').parent().addClass('has-error');
					// var $couponCodeError = Granite.I18n.get(json.eCode);
					// _this.$error.push($couponCodeError);
				  //   $instance.find('.validation-content').text(_this.$error.join(', '));
				  //   $instance.find('.validation--error-list').text(_this.$error.join(', '));
				  if(json.eCode == 'VA101'){
					  $instance.find('.couponcode-input').parent().addClass('has-error');
					  $instance.find('.couponcode-input-mob').parent().addClass('has-error');
					}
					$instance.find('.booking-error-validation').show();
					$instance.find('.error-validation').show();
					$instance.find('.validation-content').text(json.eMessage);
				} else {
					console.log("##Redirect URL: "+ json.url);
					var responseUrl = json.url;
					var redirectUrl = responseUrl.substring(0, responseUrl.indexOf('?'));
					if(window.location.pathname == "/mhapp/hq/en/travelpass.html" && typeof nativeAppCommunication != "undefined"){
					   nativeAppCommunication.openTravelPassFlow(json.url)
					}	
					else if (window.location.pathname == "/mhapp/hq/en/travelpass.html" && typeof appComm != "undefined") {
						appComm.openTravelPassFlow(json.url);
					}
					else {
					   _self.post_to_url(redirectUrl, _self.getUrlVars(responseUrl));
					 }
				}
			}
  		}, error: function(error: any) {
		 	bcommon.preloaderClose();
  			var _this = this;
			  _this.$error = [];
			  $instance.find('.booking-error-validation').show();
			  $instance.find('.error-validation').show();
			  _this.$error.push("Error while submitting form");
			  $instance.find('.validation-content').text(_this.$error.join(', '));
			  $instance.find('.validation--error-list').text(_this.$error.join(', '));
  		}
  	});
  }

  /**
   * [desktopMultiFormSubmitToServlet description]
   * @param {any} $tripflow_encryptURL [description]
   */
  desktopMultiFormSubmitToServlet($instance:any, $tripflow_encryptURL: any): void {
  	let _self = this;
  	let bcommon = _self.bcommon;
	  let ieversion = new headerContent();
	  ieversion.checkIEVersion_disablePupup();
 		bcommon.preloader();

  	// Use JQuery AJAX request to post data to a Sling Servlet
  	$.ajax({
  		type: 'POST',
  		url: '/bin/services/new/ibe',
  		data:'url='+ $tripflow_encryptURL,
  		success: function(json:any){
  			// console.log("##Successful: " + json);
  			if (json.success == "false" && json.status == "failed" && json.eCode != null) {
  				// console.log("Error while submitting form" + json);
  				bcommon.preloaderClose();
  				var _this = this;
  				_this.$error = [];
  				// $instance.find('.booking-error-validation').show();
  				// $instance.find('.couponcode-input').parent().addClass('has-error');
          		// var $couponCodeError = Granite.I18n.get(json.eCode);
  				// _this.$error.push($couponCodeError);
				// $instance.find('.validation-content').text(_this.$error.join(', '));
				if(json.eCode == 'VA101'){
					$instance.find('.couponcode-input').parent().addClass('has-error');
					$instance.find('.couponcode-input-mob').parent().addClass('has-error');
				  }
				  $instance.find('.booking-error-validation').show();
				  $instance.find('.error-validation').show();
				  $instance.find('.validation-content').text(json.eMessage);
  			} else {
  				console.log("##Redirect URL: "+ json.url);
  				var responseUrl = json.url;
  				var redirectUrl = responseUrl.substring(0, responseUrl.indexOf('?'));
  				_self.post_to_url(redirectUrl, _self.getUrlVars(responseUrl));
  			}
  		},
  		error: function(error:any) {
		 		bcommon.preloaderClose();
  			var _this = this;
  			_this.$error = [];
  			$instance.find('.booking-error-validation').show();
  			_this.$error.push("Error while submitting form");
  			$instance.find('.validation-content').text(_this.$error.join(', '));
  		}
  	});
  }

  /**
   * [mobileFormSubmitToServlet description]
   * @param {any} $tripflow_encryptURL [description]
   */
  mobileFormSubmitToServlet($instance:any, $tripflow_encryptURL:any):void {
  	let _self = this;
  	let $errorList:Array<any> = [];
  	let bcommon = _self.bcommon;

 		bcommon.preloader();

  	// Use JQuery AJAX request to post data to a Sling Servlet
  	$.ajax({
  		type: 'POST',
  		url: '/bin/services/new/ibe',
  		data:'url='+ $tripflow_encryptURL,
  		success: function(msg:any){
  			//console.log("##URL: " + this.data);
  			// console.log("##Successful: " + msg);

  			var json = msg;
  			if (json.success == "false" && json.status == "failed" && json.eCode != null) {
  				// console.log("Error while submitting form" + json);
  				bcommon.preloaderClose();
  				var _this = this;
  				$errorList = [];
  				// $instance.find('.error-validation').show();
  				// $instance.find('.couponcode-input-mob').parent().addClass('has-error');
  				// var $mobileCouponCodeError = Granite.I18n.get(json.eCode);
  				// $errorList.push($mobileCouponCodeError);
				  // $instance.find('.mobile-validation--content').text($errorList.join(', '));
				  if(json.eCode == 'VA101'){
					$instance.find('.couponcode-input').parent().addClass('has-error');
					$instance.find('.couponcode-input-mob').parent().addClass('has-error');
				  }
				  $instance.find('.booking-error-validation').show();
				  $instance.find('.error-validation').show();
				  $instance.find('.validation-content').text(json.eMessage);
  			} else {
				 var currentUrl = window.location.href;
				 var urlParamArray = currentUrl.split('/');

  				console.log("##Redirect URL: "+ json.url);
  				//window.location.replace(json.url);
				  var responseUrl = json.url;
				 
				  if(urlParamArray[3] == "hq" && urlParamArray[4] == "ar.html"){
					 responseUrl = responseUrl.replace("LANGUAGE=ar", "LANGUAGE=gb");
				 }

  				var redirectUrl = responseUrl.substring(0, responseUrl.indexOf('?'));
  				_self.post_to_url(redirectUrl, _self.getUrlVars(responseUrl));
  			}
  		},
  		error: function(error:any) {
		 		bcommon.preloaderClose();
  			var _this = this;
  			$errorList = [];
  			$instance.find('.error-validation').show();
  			$errorList.push("Error while submitting form");
  			$instance.find('.mobile-validation--content ul').append('<li>' + $errorList.join(', ') + '</li>');
  		}
  	});
  }

	/**
	 * [desktopOfficeCode description]
	 * @return {string} [description]
	 */
	desktopOfficeCode($instance:any): string {
		let $selected = $instance.find('.fromLocation').find(":selected");
		let $selected_text = $selected.text();
		let $fromOfficeID: any;
		if($selected_text.includes('|')) {
			if ($selected_text.split('|')[0] === 'Recent') {
				$fromOfficeID = $selected_text.split('|')[9].replace(/\s+/g, "");
			} else {
				$fromOfficeID = $selected_text.split('|')[1].replace(/\s+/g, "");
			}
		} else {
			$fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",")+1,$selected_text.indexOf("(")).replace(/\s+/g,"");
		}		
		return $fromOfficeID;
	}

	/**
	 * [mobileOfficeCode description]
	 * @return {string} [description]
	 */
	mobileOfficeCode($instance:any): string {
		let $selected = $instance.find('.ibe-mob-from--location').find(":selected");
		let $selected_text = $selected.text();
		let $fromOfficeID: any;
		if ($selected_text.includes('|')) {
			if ($selected_text.split('|')[0] === 'Recent') {
				$fromOfficeID = $selected_text.split('|')[9].replace(/\s+/g, "");
			} else {
				$fromOfficeID = $selected_text.split('|')[1].replace(/\s+/g, "");
			}
		} else {
			$fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
		}
		return $fromOfficeID;
	}

	sidetripEligibilityCheck($data: any) {
		let _self = this;
		let bcommon = _self.bcommon;
		var dataParse: any = null;
		//bcommon.preloader();		
		let sidetripEligibilityurl: string = '';
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			sidetripEligibilityurl = '/dummy-data/sidetripeligibility.json';
		}
		else {
			sidetripEligibilityurl = '/bin/services/new/sidetripeligibility';
		}

		$.ajax({
			type: 'GET',
			url: sidetripEligibilityurl,
			data: $.param($data),
			async: false,
			success: function (data: any) {
				//bcommon.preloaderClose();				
				if (typeof data === 'string') {
					dataParse = JSON.parse(data);
				}
				else {
					dataParse = data;
				}						
			},
			error: function (error: any) {
				//bcommon.preloaderClose();
				dataParse = null;		
			}
		});	
		return dataParse;	
	}
}
